import React from 'react'
import styled from 'styled-components'

/* eslint-disable */
const Container = styled(({ tag = 'div', ...props }) => (
  <div as={tag} {...props}/>
))`
  margin: 0 auto;
  position: relative;
  width: 83.3%;
  min-height: 60vh;
  max-width: 75rem;
  padding: 1.5rem 0 3.75rem;

  ${({ theme }) => theme.mediaQueries.tabletPortraitUp} {
    padding: 2rem 0 3.75rem;
  }

  ${({ theme }) => theme.mediaQueries.phoneOnly} {
    width: calc(100% - 36px);
  }
 
@media (min-width: 600px) and (max-width: 1024px) {
  width: calc(100% - 48px);
}
`
Container.displayName = 'Container'

export default Container
